import ReCAPTCHA from 'react-google-recaptcha';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Pages/LeadVettingPage/components/LeadVettingFormStyles.module.less';
import TranslationUtils from '../Utils/TranslationUtils';

const Captcha = (props) => {
  const isAutomation = document.cookie.indexOf('automation_tests') > -1;

  if (isAutomation) {
    return null;
  }

  return (
    <div className={[styles.fieldRow, styles.captcha].join(' ')}>
      <div className={styles.recaptchaSection}>
        <ReCAPTCHA
          onChange={props.onChange}
          className={`recaptcha-wrap ${styles.g_recaptcha}`}
          sitekey={window.__CONFIG__.RECAPTCHA_KEY}
        />
      </div>
      {props.error && (
        <div test-id="error-captcha" className="error-label">
          {TranslationUtils.getText(props.error)}
        </div>
      )}
    </div>
  );
};

Captcha.propTypes = {
  error: PropTypes.string,
  onChange: PropTypes.func,
};
export default Captcha;
